import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { AppBar } from '../AppBar';
import { Navigation } from '../Navigation';
import { SideNav } from '../SideNav';
import { SessionFloatingActions } from '@components/observation/SessionFloatingActions';
import { ExitSessionDialog } from '@components/common/ExitSessionDialog';
import { useDeviceType } from '@hooks/useDeviceType';
import { useServiceWorkerUpdate } from '@hooks/useServiceWorkerUpdate';
import { useSessionNavigationStore } from '@store/session-navigation-store';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@hooks/useSession';

export function Layout() {
  useServiceWorkerUpdate();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'mobile';
  const navigate = useNavigate();
  const {
    activeSessionId,
    showExitConfirmation,
    setShowExitConfirmation,
    clearActiveSession,
  } = useSessionNavigationStore();
  const { updateSessionStatus } = useSession(activeSessionId ?? undefined);

  const handleContinueRecording = () => {
    setShowExitConfirmation(false);
  };

  const handleSaveAndExit = async () => {
    if (activeSessionId) {
      setShowExitConfirmation(false);
      await updateSessionStatus(activeSessionId, 'completed');
      clearActiveSession();
      navigate(`/session/${activeSessionId}/review`);
    }
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {!isMobile && <SideNav />}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <AppBar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            backgroundColor: 'background.default',
            pb: isMobile ? 8 : 2,
          }}
        >
          <Outlet />
        </Box>
        {isMobile && <Navigation />}
      </Box>

      <SessionFloatingActions />

      <ExitSessionDialog
        open={showExitConfirmation}
        onContinue={handleContinueRecording}
        onSaveAndExit={handleSaveAndExit}
      />
    </Box>
  );
}
